export default __webpack_public_path__ + "static/media/img_muslinTwoBunnyEars_yg.5f82e63f.jpg";